import { FeatureFlagName } from "../../../mp-utils/generic-utils/feature-flags/types"

export const REPORTING_HIDDEN_PROGRAMS = ["CMAS", "ILEARN", "ISA", "SAT"]

export const REPORTING_QUESTIONS_AVAILABLE_PROGRAMS = ["EACT", "DSAT", "TSIA2"]

export const FIELDS_WITH_FEATURE_FLAGS_DEPS: Record<string, string[]> = {
  [FeatureFlagName.reporting_average_time_spent_data]: [
    // Content
    "content_view_list.averageTimeSpent",
    "content_view_br_lessons.averageTimeSpent",
    "content_view_mc_lessons.averageTimeSpent",
    "content_view_ml_lessons.averageTimeSpent",
    "content_view_sh_lessons.averageTimeSpent",
    "content_view_tests.averageTimeSpent",
    "content_view_subtests.averageTimeSpent",

    // Org
    "org_view_classes.averageTimeSpent",
    "org_view_districts.averageTimeSpent",
    "org_view_schools.averageTimeSpent",
    "org_view_states.averageTimeSpent",
    "org_view_students.averageTimeSpent",

    // Usage
    "usage_students.averageTimeSpent"
  ],
  [FeatureFlagName.reporting_content_library_average_accuracy]: [
    // Content
    "content_view_sh_lessons.accuracy",
    "content_view_ml_lessons.accuracy",
    "content_view_mc_lessons.accuracy"
  ],
  [FeatureFlagName.reporting_average_days_active_data]: [
    // Org
    "avegare_time_spent_view.avgTimeSpent",
    "org_view_teachers.averageDaysActive"
  ],
  [FeatureFlagName.reporting_content_library_reporting_categories]: [
    "content_view_list.nodeNames",
    "content_view_br_lessons.nodeNames",
    "content_view_sh_lessons.nodeNames",
    "content_view_tests.nodeNames",
    "content_view_ml_lessons.nodeNames",
    "content_view_mc_lessons.nodeNames"
  ],
  [FeatureFlagName.reporting_content_library_standards]: [
    "content_view_list.standards",
    "content_view_br_lessons.standards",
    "content_view_sh_lessons.standards",
    "content_view_ml_lessons.standards"
  ],
  [FeatureFlagName.reporting_insights_performance_questions_viewed]: [
    "questions_view.viewedCount"
  ],
  [FeatureFlagName.reporting_insights_performance_questions_standard]: [
    "questions_view.standards"
  ],
  [FeatureFlagName.reporting_insights_activity_log_time_spent]: [
    "usage_activity_logs.timeSpent"
  ],
  [FeatureFlagName.reporting_grade_column]: [
    "org_view_students.grade",
    "scores_view.grade",
    "scores_subtests_view.grade",
    "usage_students.grade"
  ],
  [FeatureFlagName.reporting_activity_log_content_column]: [
    "usage_activity_logs.contentName"
  ],
  [FeatureFlagName.reporting_skills_filter]: ["shownSkills"]
}

export const WIDGETS_UNDER_FEATURE_FLAGS: Record<string, string[]> = {
  [FeatureFlagName.reporting_average_time_spent_data]: [
    "AverageStudentTimeSpent",
    "ContentTypeBellRingersAverageTimeSpent",
    "ContentTypePracticeTestAverageTimeSpent",
    "ContentTypeMasteryCurriculumAverageTimeSpent",
    "ContentTypeMasteryLessonsAverageTimeSpent",
    "ContentTypeSkillReviewAverageTimeSpent"
  ],
  [FeatureFlagName.reporting_content_library_widgets]: [
    "ContentTypeBellRingers",
    "ContentTypeMasteryLessons",
    "ContentTypePracticeTests",
    "ContentTypeMasteryCurriculum",
    "ContentTypeSkillReview",
    "ContentTypeBellRingersAverageTimeSpent",
    "ContentTypePracticeTestAverageTimeSpent",
    "ContentTypeMasteryCurriculumAverageTimeSpent",
    "ContentTypeMasteryLessonsAverageTimeSpent",
    "ContentTypeSkillReviewAverageTimeSpent",
    "ContentTypeMasteryCurriculumAverageAccuracy",
    "ContentTypeMasteryLessonsAverageAccuracy",
    "ContentTypeSkillReviewAverageAccuracy",
    "ContentTypePracticeTestsAverageScore"
  ],
  [FeatureFlagName.reporting_content_library_average_accuracy]: [
    // Content
    "ContentTypeSkillReviewAverageAccuracy",
    "ContentTypeMasteryLessonsAverageAccuracy",
    "ContentTypeMasteryCurriculumAverageAccuracy"
  ],
  [FeatureFlagName.reporting_content_library_skill_review_mastery_curriculum]: [
    "ContentTypeMasteryCurriculum",
    "ContentTypeSkillReview"
  ],
  [FeatureFlagName.reporting_average_days_active_data]: ["AverageDaysActive"]
}

export const FILTERS_BY_ROUTE_UNDER_FEATURE_FLAGS: Record<
  string,
  Record<string, string[]>
> = {
  [FeatureFlagName.reporting_content_library_date_filter]: {
    "/reporting/content/content-library": ["date"],
    "/reporting/content/content-library/:entityType/:entityId": ["date"]
  },
  [FeatureFlagName.reporting_insights_performance_questions_content_filter]: {
    "/reporting/insights/performance/questions": ["content"]
  },
  [FeatureFlagName.reporting_skills_filter]: {
    "/reporting/content/content-library": ["skill"],
    "/reporting/insights/performance/questions": ["skill"]
  },
  [FeatureFlagName.reporting_activity_filter]: {
    "/reporting/insights/usage/activity-log": ["activity"],
    "/reporting/content/content-library/:entityType/:entityId": ["activity"],
    "/reporting/organization/teachers/:entityId": ["activity"],
    "/reporting/organization/classes/:entityId": ["activity"],
    "/reporting/organization/students/:entityId": ["activity"]
  },
}
